import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { MMealResponse, MealTypeResponse } from "../openapi/client";

export interface IMealSlice {
  list: MMealResponse[];
  types: MealTypeResponse[];
}

const initialState: IMealSlice = { list: [], types: [] };

export const mealSlice = createSlice({
  name: "meal",
  initialState,
  reducers: {
    setMealList: (state, action: PayloadAction<MMealResponse[]>) => {
      return {
        ...state,
        list: [...action.payload],
      };
    },
    setMealTypes: (state, action: PayloadAction<MealTypeResponse[]>) => {
      return {
        ...state,
        types: [...action.payload],
      };
    },
    resetMeal: (state) => {
      return {
        ...state,
        list: [],
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setMealList, setMealTypes, resetMeal } = mealSlice.actions;
export default mealSlice.reducer;
